import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

const HomePage = () => {
  const navigate = useNavigate();
  const id = localStorage.getItem("username");

  useEffect(() => {
    if (id) {
      navigate("/page");
    }
  }, [id, navigate]);

  return (
    <div className="min-h-screen bg-[#F5F7FB] overflow-hidden relative">
      <Header btn={"Login"} path={"/login"} />

      {/* BACKGROUND EFFECTS */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-[-180px] left-[-100px] w-[420px] h-[420px] rounded-full bg-[#4F46E5]/10 blur-3xl"></div>

        <div className="absolute bottom-[-180px] right-[-100px] w-[420px] h-[420px] rounded-full bg-[#14B8A6]/10 blur-3xl"></div>
      </div>

      {/* MAIN SECTION */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-[95px]">
        
        <div className="grid lg:grid-cols-[45%_55%] items-center min-h-[78vh] gap-6">
          
          {/* LEFT SIDE */}
          <div>
            
            
            {/* HEADING */}
            <div className="mt-7">
              <h1 className="text-5xl lg:text-6xl font-black leading-[0.95] tracking-[-3px]">
                
                <span className="text-gray-800">
                  Detect
                </span>

                <br />

                <span className="bg-gradient-to-r from-[#4F46E5] via-[#6366F1] to-[#14B8A6] bg-clip-text text-transparent">
                  Pneumonia
                </span>

                <br />

                <span className="text-gray-800">
                  with AI Precision
                </span>
              </h1>
            </div>

            {/* DESCRIPTION */}
            <p className="mt-6 text-lg leading-8 text-gray-600 max-w-xl">
              Accelerate pneumonia diagnosis using intelligent chest X-ray
              analysis. CheXCare delivers rapid AI-powered insights that
              support faster clinical decisions and improve patient outcomes.
            </p>

            {/* BUTTONS */}
            <div className="flex items-center mt-9">
              
              <a href="/signup">
                <button className="px-8 py-4 rounded-2xl bg-gradient-to-r from-[#4F46E5] to-[#6366F1] text-white font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                  Start Free
                </button>
              </a>
            </div>

            {/* STATS */}
            <div className="grid grid-cols-3 gap-6 mt-12">
              
              <div>
                <h2 className="text-3xl font-bold text-[#4F46E5]">
                  74%
                </h2>

                <p className="text-gray-500 mt-1 text-sm">
                  Detection Accuracy
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold text-[#14B8A6]">
                  16.2s
                </h2>

                <p className="text-gray-500 mt-1 text-sm">
                  Scan Time
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold text-[#4F46E5]">
                  24/7
                </h2>

                <p className="text-gray-500 mt-1 text-sm">
                  AI Monitoring
                </p>
              </div>
            </div>

           
          </div>

          {/* RIGHT SIDE */}
          <div className="relative flex items-center justify-center">
            
            {/* MAIN ORB */}
            <div className="absolute w-[480px] h-[480px] rounded-full bg-gradient-to-br from-[#4F46E5] via-[#6366F1] to-[#14B8A6] opacity-20 blur-3xl"></div>

            {/* SMALL ORB */}
            <div className="absolute top-10 right-10 w-[170px] h-[170px] rounded-full bg-[#14B8A6]/20 blur-2xl"></div>

            {/* FLOATING CARD */}
            <div className="absolute top-20 left-2 bg-white shadow-2xl rounded-3xl px-5 py-4 border border-gray-100 z-20 hidden lg:block">
              
              <p className="text-gray-500 text-sm">
                AI Diagnosis
              </p>

              <h3 className="text-xl font-bold text-green-500 mt-1">
                Normal
              </h3>
            </div>

            {/* IMAGE */}
            <img
              src="hero.png"
              alt="Doctor"
              className="relative z-10 w-[360px] lg:w-[450px] object-contain drop-shadow-[0_30px_60px_rgba(0,0,0,0.18)] hover:scale-105 transition duration-500"
            />

            {/* BOTTOM CARD */}
            <div className="absolute bottom-10 right-4 bg-white shadow-2xl rounded-3xl px-5 py-4 border border-gray-100 z-20 hidden lg:block">
              
              <p className="text-sm text-gray-500">
                Prediction Speed
              </p>

              <h3 className="text-xl font-bold text-[#4F46E5] mt-1">
                16.2 sec
              </h3>
            </div>

            {/* EXTRA CARD */}
            <div className="absolute top-8 right-14 bg-white/80 backdrop-blur-lg px-4 py-3 rounded-2xl border border-white shadow-xl hidden lg:block">
              
              <p className="text-xs text-gray-500">
                AI Confidence
              </p>

              <h3 className="text-lg font-bold text-[#14B8A6] mt-1">
                74.8%
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;